import React, { useState, useEffect, memo } from 'react';
import {
  TextField,
  IconPencilV3,
  IconCheck,
  IconLoading,
} from 'gatorcomponents';
import * as Styles from './ServerNickname.styles';

const ServerNickname = memo(({
  serverId,
  nickname,
  placeholder,
  onUpdateNickname,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState('');
  const hasNickName = Boolean(nickname);

  useEffect(() => {
    setIsLoading(false);
  }, [nickname]);

  const handleEdit = () => {
    setIsEditing(true);
    setValue(nickname != null ? nickname : '');
  };

  const handleConfirm = () => {
    if (value.length <= 20) {
      setIsEditing(false);
      setValue('');
      if (value === (nickname != null ? nickname : '')) {
        return;
      }
      onUpdateNickname(serverId, value);
      setIsLoading(true);
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value.slice(0, 20));
  };

  if (isEditing) {
    return (
      <Styles.NicknameEditContainer>
        <Styles.NicknameEditTextField>
          <TextField
            value={value}
            onChange={handleChange}
            onClear={() => setValue('')}
            placeholder={placeholder}
            label={null}
            inputHeight={46}
            maxLength={20}
            autoFocus
          />
        </Styles.NicknameEditTextField>
        <Styles.NicknameConfirmButton onClick={handleConfirm}>
          <IconCheck size="sm" color="highPure" />
        </Styles.NicknameConfirmButton>
      </Styles.NicknameEditContainer>
    );
  }

  if (isLoading) {
    return (
      <Styles.ServerNickName>
        <IconLoading size="sm2" />
      </Styles.ServerNickName>
    );
  }

  return (
    <Styles.ServerNickName onClick={!isLoading ? handleEdit : undefined} $hasNickname={hasNickName}>
      {hasNickName ? nickname : placeholder}
      <IconPencilV3 size="sm" color="lowMedium" />
    </Styles.ServerNickName>
  );
});

ServerNickname.displayName = 'ServerNickname';

export default ServerNickname;
